import {Component, Input, OnInit} from '@angular/core';
import {DomSanitizer} from "@angular/platform-browser";
import { GenericConfig } from '@signature-it/ngx-generic/config';
import {OwlOptions} from "ngx-owl-carousel-o";
import { WidgetService } from'@signature-it/ngx-entity/services';

@Component({
    selector: 'entity-carousel',
    templateUrl: './entity-carousel.component.html',
    styleUrls: ['./entity-carousel.component.scss'],
    standalone: false
})
export class EntityCarouselComponentGeneric implements OnInit {
    @Input() entityTypeVar: string;
    @Input() entityVar: string;
    @Input() collectionVar: string;
    @Input() entityId: number;
    @Input() isProfile = 0;
    @Input() param: string;
    @Input() key: string = 'default';
     carouselBanner: OwlOptions ;
     data: any;
     constructor( protected widgetService: WidgetService ,
     private sanitizer:DomSanitizer) {}

     ngOnInit() {
       let configOptions;
       if(Array.isArray(GenericConfig.ngxCarouselConfig)) {
           configOptions = GenericConfig.ngxCarouselConfig.find(item => item.key == this.key);
       }
       if( configOptions ){
           this.carouselBanner = configOptions.options;
       } else {
           this.carouselBanner = {
               loop: true,
               autoplay: true,
               center: true,
               dots: false,
               responsive: {
                   0: {
                       items: 1,
                   },
                   600: {
                       items: 1,
                   },
                   1000: {
                       items: 1,
                   }
               }
           };
        }
         this.widgetService.getEntityWidgetData(this.entityTypeVar, this.entityVar, this.collectionVar, this.isProfile)
            .subscribe(
                  res => {
                       if(res) {
                           let self = this;
                           this.data =  Object.keys( res['data']).map(function(Index){
                           return self.transform(res['data'][Index]);
                         });
                  }
            }
         )
     }

     transform(html) {
       return this.sanitizer.bypassSecurityTrustHtml(html);
     }
}
